import { render, staticRenderFns } from "./EditSwitchButton.vue?vue&type=template&id=1ea9d704"
import script from "./EditSwitchButton.vue?vue&type=script&lang=ts"
export * from "./EditSwitchButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports